module.exports = __webpack_public_path__ + "static/img/not_open.36a3556a.png";